/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_1Inputs */

const he_statistics_day_1 = /** @type {(inputs: Statistics_Day_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שני`)
};

const en_statistics_day_1 = /** @type {(inputs: Statistics_Day_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday`)
};

/**
* | output |
* | --- |
* | "Monday" |
*
* @param {Statistics_Day_1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_1 = /** @type {((inputs?: Statistics_Day_1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_1(inputs)
	return en_statistics_day_1(inputs)
});